// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { InfoBox } from './info-box';
import { Separator } from '@tectonics/look-and-feel/uber-v2/atoms';
import { MerchantLogo } from '@tectonics/look-and-feel/uber-v2/organisms/merchant-info';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme';

const PaymentInfoWrapper = styled.div`
  border: 1px solid #eee;
  border-radius: 3px;
  color: ${theme.colors.new_primary[900]};
`;

export const MobileLayout = styled.div`
  @media (min-width: 840px) {
    display: none;
   }
`;

export function MobileDisplayValues(): Node {
  return (
    <MobileLayout>
      <MerchantLogo height="150px" />
      <Separator direction="vertical" size={3} />
      <PaymentInfoWrapper>
        <InfoBox />
      </PaymentInfoWrapper>
    </MobileLayout>
  );
}
